import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import SolicitacaoMensalDivisaoStore from "../stores/SolicitacaoMensalDivisaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import {formatarPercentual, getCoresAzuisCinzaOuAleatoria} from "../../../utils/functions";

const FILTROS = ['COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO'];

@inject("store")
@DataWrapper
@observer
export class SolicitacaoMensalDivisao extends Component {
    constructor(props) {
        super(props);
        this.controller = new SolicitacaoMensalDivisaoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Solicitações mensais por divisão");
    }

    tooltipFormatter = (...options) => {
        return options[2].payload[options[1]+"-divisao"]
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart stackId="1" dataKeys={this.controller.rankings} data={this.controller.dados}
                                        tooltipFormatter={this.tooltipFormatter}
                                        customColor={getCoresAzuisCinzaOuAleatoria}
                                        labelAxisX={"Mês"} labelAxisY={"Quantidade"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
